import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    locationItemIcon: {
      gridArea: "Icon",
      gridRow: "1 / -1",
      alignSelf: "center",
      maxWidth: "40px",
      display: "grid",
      gridAutoFlow: "column",
      gap: "10px",
    },
    locationItemTitle: {
      gridArea: "Title",
      fontWeight: 700,
      textAlign: "left",
      color: "inherit",
    },
    locationItemSubtitle: {
      gridArea: "Subtitle",
      alignSelf: "start",
      justifySelf: "start",
      textAlign: "left",
      color: "inherit",
    },
    locationItemHours: {
      gridArea: "Details",
      alignSelf: "start",
      justifySelf: "start",
      textAlign: "left",
      display: "grid",
      gridAutoFlow: "column",
      gap: "10px",
    },
    locationItemAddress: {
      gridArea: "Address",
      fontStyle: "normal",
      textAlign: "left",
    },
    locationItemDistance: {
      gridArea: "Distance",
    },
  },
  { name: "N0LocationCard" },
);

export { useStyles };
